import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import logoSvg from '../assets/logo.svg';

const RejectedPage: React.FC = () => {
  const { pendingEmail, pendingDisplayName, signOut } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md mx-auto text-center space-y-6">

        {/* Logo */}
        <div className="flex justify-center">
          <div
            className="w-16 h-16 rounded-xl flex items-center justify-center shadow-lg bg-white border-2"
            style={{ borderColor: '#011132' }}
          >
            <img src={logoSvg} alt="Rascal EPR" className="w-12 h-12 object-contain" />
          </div>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden">
          <div
            className="p-8 text-white"
            style={{ background: 'linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%)' }}
          >
            <div className="text-5xl mb-4">🚫</div>
            <h2 className="text-2xl font-bold mb-2">Access Denied</h2>
            <p className="opacity-90 text-sm">Your access request was not approved</p>
          </div>

          <div className="p-8 space-y-4 text-left">
            {pendingDisplayName && (
              <p className="text-gray-700 font-semibold text-lg text-center">
                Hi, {pendingDisplayName}
              </p>
            )}

            {pendingEmail && (
              <div className="bg-gray-50 rounded-lg px-4 py-3 text-sm text-gray-600 break-all text-center">
                {pendingEmail}
              </div>
            )}

            <p className="text-sm text-gray-500 leading-relaxed text-center">
              Your request to access Rascal EPR was not approved. Please contact your HR Admin if you believe this is an error.
            </p>

            <button
              onClick={signOut}
              className="w-full mt-4 py-3 px-4 rounded-lg text-white text-sm font-semibold transition-colors hover:opacity-90"
              style={{ backgroundColor: '#011132' }}
            >
              Back to Sign In
            </button>
          </div>
        </div>

        <footer className="text-[10px] text-gray-400">
          © 2025 Developed by RHW | Rascal Republic | Samara Lombok
        </footer>
      </div>
    </div>
  );
};

export default RejectedPage;
